import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./sidebar.scss";

// icons
import IconRightArrow from "../static/icons/next.svg";
import IconApp from "../static/icons/apps.png";
import BrandLogoDark from "../static/icons/moxey-logo-dark.png";
import { OnlyInPc } from "../components/Responsive";
import { ArrowLeft } from "react-feather";
import { useSidebarRoutes } from "../hooks/useSidebarRoutes";
import { useLocale } from "../hooks/useLocale";
import RedirectModal from "../components/RedirectModal";
import { REDIRECT } from "../utils/redirectUrl";
import { toast } from "react-toastify";
import AuthService from "../api/auth-service";
import { AUTH_API_URL } from "../api/urlMetaData";

export const AppSidebar = () => {
  const { FooterMenu, PrimaryMenu } = useSidebarRoutes();

  return (
    <>
      <OnlyInPc>
        <Sidebar FooterMenu={FooterMenu} PrimaryMenu={PrimaryMenu} />
      </OnlyInPc>
    </>
  );
};

export const Sidebar = ({ PrimaryMenu, FooterMenu }) => {
  const navigate = useNavigate();

  const [currentMenu, setCurrentMenu] = useState(PrimaryMenu);

  // used when, item has children items and used as prop for navigating back to parent menu
  const [openedMenuItem, setOpenedMenuItem] = useState(null);
  // const [showExpenseConfirmDialog, setShowExpenseConfirmDialog] =
  //   useState(false);

  // ✅ sync whenever PrimaryMenu updates
  useEffect(() => {
    if (openedMenuItem === null) {
      setCurrentMenu(PrimaryMenu);
    }
  }, [PrimaryMenu, openedMenuItem]);

  const redirectToStackIntel = () => {
    const isMobile = /mobile|android|iphone|ipad/i.test(navigator.userAgent);
    const redirectURL = isMobile ? REDIRECT.pwa : REDIRECT.web;

    toast.promise(
      AuthService.get(AUTH_API_URL.TOKEN_FOR_PARTNER).then((res) => {
        const token = res.headers["x-stackintel-authorization"];

        window.open(
          `${redirectURL}/?xt=${token}`,
          "_blank",
          "noopener,noreferrer"
        );
      }),
      {
        pending: {
          render() {
            return "Redirecting you to Expense Management. Please wait...";
          },
        },
        error: {
          render() {
            return "Redirection to Expense Management failed.";
          },
        },
      }
    );
  };

  const switchMenu = (tab) => {
    // NEW: handle Expense Management like an external action
    if (tab.isExternal) {
      // setShowExpenseConfirmDialog(true); // state to open dialog box
      redirectToStackIntel();
      return;
    }

    if (tab.children) {
      setCurrentMenu(tab.children);
      setOpenedMenuItem(tab);
      return;
    }

    changePage(tab);
  };

  const backToMainMenu = () => {
    setCurrentMenu(PrimaryMenu);
    setOpenedMenuItem(null);
  };

  const changePage = (item) =>
    navigate(item.path[0], {
      replace: false,
    });

  return (
    <>
      <div className="app-sidebar">
        <div className="app-sidebar-header">
          <img className="moxey-logo" src={BrandLogoDark} alt="moxey-logo" />
        </div>
        <div className="app-sidebar-content">
          {/* {openedMenuItem && (
            <h4 className="menu-item heading">{openedMenuItem.name}</h4>
          )} */}
          <ul className="menu">
            {openedMenuItem && (
              <MenuItem
                isReturnable
                item={openedMenuItem}
                onchangeMenu={() => backToMainMenu()}
              />
            )}

            {currentMenu.map((tab, index) => (
              <MenuItem
                key={tab.name}
                item={tab}
                onchangeMenu={() => switchMenu(tab)}
              />
            ))}
          </ul>
        </div>
        <div className="app-sidebar-footer">
          <ul className="menu">
            {FooterMenu.map((tab) => (
              <MenuItem
                key={tab.path}
                item={tab}
                onchangeMenu={() => switchMenu(tab)}
              />
            ))}
          </ul>
        </div>

        {/* {showExpenseConfirmDialog && (
          <RedirectModal
            title={"Redirecting..."}
            onClose={setShowExpenseConfirmDialog}
          >
            <p className="text-center text-dark">
              Redirecting you to Expense Management. Please wait...
            </p>
          </RedirectModal>
        )} */}
      </div>
    </>
  );
};

export const MenuItem = ({ item, onchangeMenu, isReturnable, ...props }) => {
  const location = useLocation();
  const { localize } = useLocale();
  const isActive = (url, path) => path.includes(url);

  return (
    <>
      {isReturnable ? (
        <li className={`menu-item`} onClick={onchangeMenu}>
          <span className="">
            <ArrowLeft size={16} className="me-2" />
            {localize("common.navigation.back")}
          </span>
          {item.children && <OpenMenuIcon back />}
        </li>
      ) : (
        <>
          {item.show ? (
            <li
              className={`menu-item swipe ${
                isActive(location.pathname, item.path) ? "active" : ""
              }`}
              onClick={onchangeMenu}
              {...props}
            >
              <img className="menu-item-icon" src={IconApp} alt="" />
              {localize(
                `common.navigation.sidebarRoutes.${item.name.toLowerCase()}`,
                {
                  returnObjects: true,
                }
              )}
              {/* {item.name} */}
              {item.children && <OpenMenuIcon />}
            </li>
          ) : null}
        </>
      )}
    </>
  );
};

const OpenMenuIcon = ({ back }) => {
  return (
    <>
      <div className={`open-icon ${back ? "back" : null}`}>
        <img src={IconRightArrow} alt="right-arrow" />
      </div>
    </>
  );
};
